// ============================================================================
// CURRENCY OPTIONS
// ============================================================================

export const CURRENCY_OPTIONS = [
  { code: "USD", name: "US Dollar", symbol: "$", display: "USD - US Dollar ($)" },
  { code: "EUR", name: "Euro", symbol: "€", display: "EUR - Euro (€)" },
  { code: "GBP", name: "British Pound", symbol: "£", display: "GBP - British Pound (£)" },
  { code: "JPY", name: "Japanese Yen", symbol: "¥", display: "JPY - Japanese Yen (¥)" },
  { code: "CAD", name: "Canadian Dollar", symbol: "C$", display: "CAD - Canadian Dollar (C$)" },
  { code: "AUD", name: "Australian Dollar", symbol: "A$", display: "AUD - Australian Dollar (A$)" },
  { code: "CHF", name: "Swiss Franc", symbol: "CHF", display: "CHF - Swiss Franc" },
  { code: "MXN", name: "Mexican Peso", symbol: "$", display: "MXN - Mexican Peso ($)" },
  { code: "BRL", name: "Brazilian Real", symbol: "R$", display: "BRL - Brazilian Real (R$)" },
  { code: "ARS", name: "Argentine Peso", symbol: "$", display: "ARS - Argentine Peso ($)" },
  { code: "CLP", name: "Chilean Peso", symbol: "$", display: "CLP - Chilean Peso ($)" },
  { code: "COP", name: "Colombian Peso", symbol: "$", display: "COP - Colombian Peso ($)" },
  { code: "PEN", name: "Peruvian Sol", symbol: "S/", display: "PEN - Peruvian Sol (S/)" },
  { code: "UYU", name: "Uruguayan Peso", symbol: "$", display: "UYU - Uruguayan Peso ($)" },
  { code: "CNY", name: "Chinese Yuan", symbol: "¥", display: "CNY - Chinese Yuan (¥)" },
  { code: "INR", name: "Indian Rupee", symbol: "₹", display: "INR - Indian Rupee (₹)" },
  { code: "RUB", name: "Russian Ruble", symbol: "₽", display: "RUB - Russian Ruble (₽)" },
  { code: "ZAR", name: "South African Rand", symbol: "R", display: "ZAR - South African Rand (R)" },
  { code: "TRY", name: "Turkish Lira", symbol: "₺", display: "TRY - Turkish Lira (₺)" },
  { code: "KRW", name: "South Korean Won", symbol: "₩", display: "KRW - South Korean Won (₩)" },
];
